import { btn } from "../../../../../components/Button/buttonStyles";
const btnPrimary = btn("primary", "sm");

const MessageCard = ({
  message,
  onChange,
  onSend,
  placeholder = "Write your message...",
  disabled = false,
}) => {
  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Messages</h2>
      </div>

      <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 space-y-3">
        <textarea
          value={message}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          rows={6}
          className="w-full border border-gray-200 rounded-lg px-3 py-2 text-[13px] text-gray-900 focus:outline-none focus:ring-2 focus:ring-brand-500 resize-none"
        />

        <div>
          <button onClick={onSend} disabled={disabled} className={btnPrimary}>
            Send message to client
          </button>
        </div>
      </div>
    </section>
  );
};

export default MessageCard;
